import __request__ from "routing/request";
export function list(requestOptions) {
  return __request__("GET", "/cluster/jobs", null, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function getJob(jobId, requestOptions) {
  return __request__("GET", `/cluster/jobs/${jobId}`, null, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function cancelJob(jobId, requestOptions) {
  return __request__("DELETE", `/cluster/jobs/${jobId}`, null, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
